// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"8a94e876","123":"05ae353b","345":"f5b34946","410":"70be2c13","422":"cda29816","481":"f4c7b435","504":"6f141923","598":"40dd3b59","682":"a81fc070","708":"4de9b0d4","959":"5516b1d8"}[chunkId] + ".chunk.js";
};